import { cn } from "@/lib/utils"

interface ChallengeFooterProps {
  className?: string
  children: React.ReactNode
}

export default function ChallengeFooter({ className, children }: ChallengeFooterProps) {
  return (
    <div className={cn("flex min-h-[200px] w-full items-center justify-center", className)}>
      {children}
    </div>
  )
}
